import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable} from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AppServicesService {
baseUrl: string;
proxyBaseUrl: string  = environment.proxyEndpoint;

  constructor(private httpClient: HttpClient) {
    this.baseUrl = environment.apiEndPoint;
   }

  public anonymize(participantId: any, participantKey:any): Observable<any> {
    const baseUrl= environment.proxyEndpoint;
    const url = `${baseUrl}/stories/participants/anonymizeParticipant/${participantKey}/${participantId}`
    return this.httpClient.put(url,{}, {withCredentials: true});
  }



}
